import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';

import useBusinessGalleryCards from './hooks/useBusinessGalleryCards';

const BusinessGallery = (): JSX.Element => {
  const cards = useBusinessGalleryCards();

  return (
    <section data-cy="business-gallery">
      <LandingPageCards cards={cards} imageAspectRatio="4:3" />
    </section>
  );
};

export default BusinessGallery;
